module.exports = __webpack_public_path__ + "static/media/bensound-ukulele.c1448912.mp3";